import { object, string, number, array } from 'yup';
import SEPProfession from '../SEPComponent/SEPProfession';
import SuccessPopUP from '../../../UserKyc/UserPopUP/IncomeSuccessPopUp';
import companyAddress from '../../SENP/AddCompanyAddress';
import AddressProof from '../../SENP/BusinessAddressProof';
import moment from 'moment';
import BusinessDetails from '../SEPComponent/BusinessDetails/BusinessDetails';
import * as Yup from 'yup';
import PersonalDetails from '../../PersonalDetails/PersonalDetails';
import OtherSavings from '../../../Income/IncomeDetailsComponent/OtherSaving/OtherSaving';
import AddSalary from '../../../Income/IncomeDetailsComponent/SalaryDetails/AddSalary';
import AddLoan from '../../LoanDetails/AddLoan';
import { getApplicantionInfo } from '../../../../common/utils/applicantionInfo';
import { saveOthersSaving } from '../../../../common/constants/api';
import * as _ from 'lodash';
import { currentYear } from '../../../../components/Dashboard-res/CommonComponent/CommonDatePicker';
import ITR from '../../SENP/IncomeFiles/ITR';
let viewAccount = false;

export const isViewAccount = () => {
  return viewAccount;
};

let allValues = { step: 'SEP' };
export const getAllValues = () => allValues;

const Steps = [
  {
    id: 'SEPProfession',
    component: SEPProfession,
    initialValues: {
      isEditMode: false,
      professionType: '',
      doctorQualification: {
        label: 'Select Professional qualification',
        value: ''
      },
      doctorRegistrationNumber: '',
      doctorRegistrationYear: { label: false, value: 'Years of registration' },
      medicalCouncil: {
        label: '',
        value: ''
      },
      CA_CS_ICWAI_Qualification: {
        label: 'Select Professional qualification',
        value: ''
      },
      CA_CS_ICWAI_MemberShipNo: '',
      CA_CS_ICWAI_CpNumber: '',

      file: [],
      imgUrl: []
    },
    validationSchema: object().shape({
      doctorQualification: string().when('professionType', {
        is: 'Doctor',
        then: val => {
          return object().shape({
            value: string().required('Required')
          });
        }
      }),
      doctorRegistrationNumber: string().when('doctorQualification.value', {
        is: '1',
        then: string().required('Required')
      }),

      doctorRegistrationYear: string().when('doctorQualification.value', {
        is: '1',
        then: string().required('Required')
      }),
      medicalCouncil: string().when('doctorQualification.value', {
        is: '1',
        then: val => {
          return object().shape({
            value: string().required('Required')
          });
        }
      }),
      CA_CS_ICWAI_Qualification: string().when('professionType', {
        is: 'CA/CS/ICWAI',
        then: val => {
          return object().shape({
            value: string().required('Required')
          });
        }
      }),
      CA_CS_ICWAI_MemberShipNo: string().when('professionType', {
        is: 'CA/CS/ICWAI',
        then: string().required('Required')
      }),
      CA_CS_ICWAI_CpNumber: string().when('CA_CS_ICWAI_Qualification.value', {
        is: '9',
        then: string().required('Required')
      }),

      file: array().when('isEditMode', {
        is: false, // alternatively: (val) => val == true
        then: array()
          .required('file is required')
          .of(string().required())
      }),
      imgUrl: string().when('isEditMode', {
        is: false, // alternatively: (val) => val == true
        then: string().required('file is required')
      })
    }),

    onAction: async (sectionValues, formValues) => {}
  },
  {
    id: 'companyAddress',
    component: companyAddress,
    initialValues: {
      address: '',
      source: '',
      preAddress: false,
      currentAddress: 'no',
      step: 'sep'
    },
    validationSchema: object().shape({
      currentAddress: string().when('preAddress', {
        is: true,
        then: string().required('required')
      })
    }),

    onAction: async (sectionValues, formValues) => {
      allValues['companyAddress'] = sectionValues;
    }
  },
  {
    id: 'addProof',
    component: AddressProof,
    initialValues: {
      add_proof: { value: '', label: 'Select Business Address Proof' },
      UploadRent: 0,
      file: [],
      imgUrl: [],
      preValues: getAllValues,
      utilityBIll: { value: '', label: 'Select Utility Bill' }
    },
    onAction: async (sectionValues, formValues) => {}
  },
  {
    id: 'businessDet',
    component: BusinessDetails,
    initialValues: {
      clinicfirm: '',
      workers: '',
      registrationdate: {
        value: '',
        label: 'Date'
      },
      month: {
        value: '',
        label: 'Month'
      },
      year: {
        value: moment().year(),
        label: moment().year()
      },
      commencementdate: {
        value: '',
        label: 'Date'
      },
      commmonth: {
        value: '',
        label: 'Month'
      },
      commyear: {
        value: moment().year(),
        label: moment().year()
      }
    }
  },
  {
    id: 'itr',
    component: ITR,
    initialValues: {
      file: [],
      imgUrl: [],
      pincode: '',
      statementType: 'individual'
    },
    validate: values => {
      const error = {};
      if (!values.preValues) {
        if (!values.file[0] && !values.file[1] && !values.file[2]) {
          error['error'] = true;
        }
        return error;
      }
    },
    onAction: async (sectionValues, formValues) => {}
  },
  {
    id: 'AddSalary',
    component: AddSalary,
    initialValues: {
      professionType: '',
      file: [],
      imgUrl: [],
      accountNo: '',
      ifscCode: '',
      statementType: '',
      viewAccount: isViewAccount,
      addNewAccount: true,
      preValues: getAllValues,
      accountType: 'current'
    },
    validationSchema: Yup.object().shape({
      accountNo: Yup.string().when('addNewAccount', {
        is: true,
        then: Yup.string()
          .required('Required')
          .min(9, 'Account Number Must be minimum 9 digits')
          .max(18, 'Account Number should not excced 18 digits')
      }),
      ifscCode: Yup.string().when('addNewAccount', {
        is: true,
        then: Yup.string()
          .required('Required')
          .matches(/^[A-Za-z]{4}0[A-Z0-9a-z]{6}$/, 'Invalid IFSC code Format')
      }),

      statementType: Yup.string().when('addNewAccount', {
        is: true,
        then: Yup.string().required('Required')
      })
    }),

    onAction: (sectionValues, formValues) => {}
  },
  {
    id: 'otherSaving',
    component: OtherSavings,
    initialValues: {
      gold: false,
      mutualFunds: false,
      pF: false,
      fD: false,
      uL: false,
      fA: false
    },
    validationSchema: Yup.object().shape({}),
    onAction: async (sectionValues, formValues) => {
      let data = getApplicantionInfo();
      const { leadId, leadApplicantId } = data;
      await saveOthersSaving(leadId, leadApplicantId, {
        isGold: sectionValues.gold,
        isMutualFund: sectionValues.mutualFunds,
        isPf: sectionValues.pF,
        isFdOrRd: sectionValues.fD,
        isUlOrIp: sectionValues.uL,
        isFixedAssests: sectionValues.fA
      }).catch(err => {
        throw new Error(
          err?.response?.data?.message ||
            'something went wrong please try again. .'
        );
      });
    }
  },
  {
    id: 'AddLoan',
    component: AddLoan,
    initialValues: {
      file: [],
      imgUrl: [],
      lender: '',
      loanType: '',
      sanctionAmount: '',
      balanceAmount: '',
      totalTenure: '',
      balanceTenure: '',
      sanctionDocId: null,
      statementDocId: null,
      viewAccount: isViewAccount,
      addNewLoan: true
    },
    validationSchema: Yup.object().shape({
      lender: Yup.string().when('addNewLoan', {
        is: true,
        then: Yup.string().required('Required')
      }),
      loanType: Yup.string().when('addNewLoan', {
        is: true,
        then: Yup.string().required('Required')
      }),
      sanctionAmount: Yup.string().when('addNewLoan', {
        is: true,
        then: Yup.string().required('Required')
      }),
      balanceAmount: Yup.string().when('addNewLoan', {
        is: true,
        then: Yup.string().required('Required')
      }),
      totalTenure: Yup.string().when('addNewLoan', {
        is: true,
        then: Yup.string().required('Required')
      }),
      currentEmi: Yup.string().when('addNewLoan', {
        is: true,
        then: Yup.string().required('Required')
      }),
      balanceTenure: Yup.string().when('addNewLoan', {
        is: true,
        then: Yup.string().required('Required')
      })
    }),
    onAction: (sectionValues, formValues) => {}
  },
  {
    id: 'PersonalDetails',
    component: PersonalDetails,
    initialValues: {
      maritalStatus: {
        label: 'Marital Status',
        value: ''
      },
      religion: {
        label: 'Religion',
        value: ''
      },

      category: {
        label: 'Category',
        value: ''
      },
      residential: {
        label: 'Residential Status',
        value: ''
      },
      file: [],
      imgUrl: []
    },
    validationSchema: Yup.object().shape({
      maritalStatus: Yup.object().shape({
        value: Yup.string().required('Required')
      }),
      religion: Yup.object().shape({
        value: Yup.string().required('Required')
      }),
      category: Yup.object().shape({
        value: Yup.string().required('Required')
      }),
      residential: Yup.object().shape({
        value: Yup.string().required('Required')
      })
    })
  },
  {
    id: 'SuccessPopUP',
    component: SuccessPopUP
  }
];
export default Steps;
